
import React from 'react';

interface LogoProps {
    className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = "h-8 w-auto" }) => {
    // Unique ID for the gradient to prevent conflicts if multiple SVGs are on the page
    const gradientId = "bytecohort_logo_gradient";

    return (
        <svg 
            className={className} 
            viewBox="0 0 350 60" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="Bytecohort Reach Logo"
        >
            <defs>
                <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#2dd4bf" /> {/* teal-400 */}
                    <stop offset="100%" stopColor="#3b82f6" /> {/* blue-500 */}
                </linearGradient>
            </defs>

            {/* Icon Group */}
            <g transform="translate(5, 5)">
                <path 
                    d="M25 5 C12.8 5 3 13.9 3 25 C3 30.2 5.1 34.9 8.6 38.5 L5 50 L18 45.5 C20.2 46.5 22.5 47 25 47 C37.2 47 47 38.1 47 25 C47 13.9 37.2 5 25 5 Z" 
                    stroke={`url(#${gradientId})`} 
                    strokeWidth="2.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                />
                <circle cx="25" cy="25" r="3.5" fill="#2dd4bf" />
                <line x1="25" y1="25" x2="25" y2="12" stroke="#2dd4bf" strokeWidth="1.5" />
                <circle cx="25" cy="12" r="2" fill="#2dd4bf" />
                <line x1="25" y1="25" x2="36" y2="32" stroke="#3b82f6" strokeWidth="1.5" />
                <circle cx="36" cy="32" r="2" fill="#3b82f6" />
                <line x1="25" y1="25" x2="14" y2="32" stroke="#2dd4bf" strokeWidth="1.5" />
                <circle cx="14" cy="32" r="2" fill="#2dd4bf" />
            </g>

            {/* Text Group - Using sans-serif fallback to ensure text always renders */}
            <text x="60" y="40" fontFamily="ui-sans-serif, system-ui, sans-serif" fontWeight="bold" fontSize="28" fill="#2dd4bf" letterSpacing="-0.5">Bytecohort</text>
            <text x="212" y="40" fontFamily="ui-sans-serif, system-ui, sans-serif" fontWeight="normal" fontSize="28" fill="#3b82f6">Reach</text>
        </svg>
    );
};
